module.exports = __webpack_public_path__ + "fonts/4ed7efd.woff2";